/** Stops dictation before submission. @returns Whether the query allowed a submit attempt. */
export function submitAskInputDictation({ hasQuery, onStopTranscription, onSubmit, }) {
    onStopTranscription?.();
    if (!hasQuery)
        return false;
    onSubmit();
    return true;
}
//# sourceMappingURL=submitAskInputDictation.js.map